import Nopage from '../../assets/404 error/404.jpg'
const NoPage=()=>{
    <>
        <div className="container-fluid">
            <div className="container">
                <img scr={Nopage} alt="404 no page found"/>
            </div>
        </div>
    </>
}

export default NoPage